export default "__VITE_ASSET__Cl$94x9C__"